import * as Yup from 'yup';
import { DEFAULT_LANG, LANGUAGE_BY_DOMAIN } from '../../../utils/constants';

export function getDynamicFeatureCategoryFields() {
  let dynamicFields = {};
  LANGUAGE_BY_DOMAIN.forEach(item => {
    dynamicFields = {
      ...dynamicFields,
      [`feature${item[1]}`]: '',
    };
  });
  return dynamicFields;
}

function getInitialFormData() {
  const dynamicFields = getDynamicFeatureCategoryFields();
  const initialFormData = {
    isMultiLang: 'false',
    ...dynamicFields,
  };

  return initialFormData;
}

export const featuresInitialFormData = getInitialFormData();

export function featuresValidationSchema(isMultiLangFlag) {
  let validationFields = {
    [`feature${DEFAULT_LANG.value}`]: Yup.string()
      .min(3, 'Minimum of 3 characters required')
      .required(`Feature(${DEFAULT_LANG.label}) is required!`),
  };

  LANGUAGE_BY_DOMAIN.filter(item => DEFAULT_LANG.value !== item[1]).forEach(([label, value]) => {
    if (isMultiLangFlag) {
      validationFields = {
        ...validationFields,
        [`feature${value}`]: Yup.string()
          .min(3, 'Minimum of 3 characters required')
          .required(`Feature(${label}) is required!`),
      };
    } else {
      validationFields = {
        ...validationFields,
        [`feature${value}`]: Yup.string(),
      };
    }
  });

  return Yup.object().shape({
    isMultiLang: Yup.string(),
    ...validationFields,
  });
}
